// import React, { useState } from "react";
// import "./Payouts.css";
// import FinanceOverview from "./FinanceOverview";
// import SalaryPayout from "./SalaryPayout";
// import SalaryOnHand from "./SalaryOnHand";
// import SalaryRevision from "./SalaryRevision";

// const TabsLayout = () => {
//   const [activeTab, setActiveTab] = useState("GENERAL_SETTINGS");

//   const DummySection = ({ title }) => (
//     <div className="dummy-box">
//       <h2>{title}</h2>
//       <p>This is a dummy section for <strong>{title}</strong>.</p>
//       <span>Content will be added later 🚧</span>
//     </div>
//   );

//   const renderComponent = () => {
//     switch (activeTab) {
//       case "GENERAL_SETTINGS":
//         return <DummySection />;
//       case "COMPONENTS":
//         return <DummySection />;
//       case "CREATE_STRUCTURE":
//         return <DummySection title="CREATE_STRUCTURE" />;
//       case "PAYSLIP_STRUCTURE":
//         return <DummySection title="PAYSLIP_STRUCTURE" />;
//         case "ASSIGN_STRUCTURE":
//         return <DummySection title="ASSIGN_STRUCTURE" />;
//         case "ACCESS_CONTROL":
//         return <DummySection title="ACCESS_CONTROL" />;
//         case "PF":
//         return <DummySection title="PF" />;
//         case "ESI":
//         return <DummySection title="ESI" />;
//         case "PT":
//         return <DummySection title="PT" />;
//         case "INCOME_TAX":
//         return <DummySection title="INCOME_TAX" />;
//         case "HEALTH_INSURANCE":
//         return <DummySection title="HEALTH_INSURANCE" />;
//         case "BANK_INTEGRATION":
//         return <DummySection title="BANK_INTEGRATION" />;
//       default:
//         return <DummySection />;
//     }
//   };

//   const tabs = [
//     "GENERAL_SETTINGS",
//     "COMPONENTS",
//     "CREATE_STRUCTURE",
//     "PAYSLIP_STRUCTURE",
//     "ASSIGN_STRUCTURE",
//     "ACCESS_CONTROL",
//     "PF",
//     "ESI",
//     "PT",
//     "INCOME_TAX",
//     "HEALTH_INSURANCE",
//     "BANK_INTEGRATION"
//   ];

//   return (
//     <div className="tabs-wrapper">
//       {/* TOP ONE-ROW TABS (ALL SCREENS) */}
//       <div className="tabs-row">
//         {tabs.map((tab) => (
//           <span
//             key={tab}
//             className={`row-tab ${activeTab === tab ? "active" : ""}`}
//             onClick={() => setActiveTab(tab)}
//           >
//             {tab}
//           </span>
//         ))}
//       </div>

//       {/* CONTENT */}
//       <div className="tabs-content">
//         {renderComponent()}
//       </div>
//     </div>
//   );
// };

// export default TabsLayout;



import React, { useState } from "react";
import "./Fmsetting.css";
import GeneralSetting from "./GeneralSetting";
import FinanceComponent from "./FinanceComponent";
import FmSalaryStructure from "./FmSalaryStructure";
import Fmpayslips from "./Fmpayslips";
import Asignstructure from "./Asignstructure";
import AccessControl from "./AccessControl";
import ProvidentFund from "./ProvidentFund";
import ESIStatus from "./ESIStatus";
import PTStatus from "./PTStatus";
import IncomeTax from "./IncomeTax";
import HealthInsurance from "./HealthInsurance";
import ICICIBanking from "./ICICIBanking";  

const PayoutTabsLayout = () => {
  const [activeTab, setActiveTab] = useState("GENERAL_SETTINGS");

  const DummySection = ({ title }) => (
    <div className="paytabs-dummy-box">
      <h2>{title}</h2>
      <p>
        This is a dummy section for <strong>{title}</strong>.
      </p>
      <span>Content will be added later 🚧</span>
    </div>
  );

  
  const renderComponent = () => {
    switch (activeTab) {
      case "GENERAL_SETTINGS":
        return <GeneralSetting />;
      case "COMPONENTS":
        return <FinanceComponent />;
      case "CREATE_STRUCTURE":
        return <FmSalaryStructure title="CREATE_STRUCTURE" />;
      case "PAYSLIP_STRUCTURE":
        return <Fmpayslips title="PAYSLIP_STRUCTURE" />;
        case "ASSIGN_STRUCTURE":
        return <Asignstructure title="ASSIGN_STRUCTURE" />;
        case "ACCESS_CONTROL":
        return <AccessControl title="ACCESS_CONTROL" />;
        case "PF":
        return <ProvidentFund title="PF" />;
        case "ESI":
        return <ESIStatus title="ESI" />;
        case "PT":
        return <PTStatus title="PT" />;
        case "INCOME_TAX":
        return <IncomeTax title="INCOME_TAX" />;
        case "HEALTH_INSURANCE":
        return <HealthInsurance title="HEALTH_INSURANCE" />;
        case "BANK_INTEGRATION":
        return <ICICIBanking title="BANK_INTEGRATION" />;
      default:
        return <GeneralSetting />;
    }
  };

  const tabs = [
    "GENERAL_SETTINGS",
    "COMPONENTS",
    "CREATE_STRUCTURE",
    "PAYSLIP_STRUCTURE",
    "ASSIGN_STRUCTURE",
    "ACCESS_CONTROL",
    "PF",
    "ESI",
    "PT",
    "INCOME_TAX",
    "HEALTH_INSURANCE",
    "BANK_INTEGRATION"
  ];

  return (
    <div className="paytabs-wrapper">
      {/* TABS */}
      <div className="paytabs-tabs-row">
        {tabs.map((tab) => (
          <span
            key={tab}
            className={`paytabs-row-tab ${
              activeTab === tab ? "paytabs-active" : ""
            }`}
            onClick={() => setActiveTab(tab)}
          >
            {tab.replace(/_/g, " ")}
          </span>
        ))}
      </div>

      {/* CONTENT */}
      <div className="paytabs-content">{renderComponent()}</div>
    </div>
  );
};

export default PayoutTabsLayout;
